<template>
    <div class="d-flex justify-center">
        <v-card
            :width="mobile ? '90%' : '65%'"
            max-height="78vh"
            color="white"
            elevation="3"
            class="d-flex flex-column"
        >
            <v-data-table-server
                :headers="transfer.headers"
                :items="transfer.lstTransfer"
                :items-per-page="transfer.itemsPerPage"
                no-data-text="Nenhuma transferência encontrada"
                @click:row="openTransfer"
                class="card-scroll"
                :page="transfer.page"
                :items-length="transfer.totalItems"
                @update:options="updateOptions"
            >
            <template v-slot:top>
                    <div :class="['px-5', mobile ? 'pb-3' : '']">
                        <v-row align="center" dense>
                            <v-col cols="12" md="9">
                                <v-text-field
                                    v-model="transfer.search"
                                    label="Pesquise aqui"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    max-width="300px"
                                    rounded
                                    class="pt-6"
                                    @keyup.enter="search()"
                                >
                                    <template v-slot:append-inner>
                                        <v-btn
                                            icon
                                            size="small"
                                            variant="text"
                                            @click="search()"
                                        >
                                        <v-icon class="pt-1">mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex justify-end">
                                <v-btn
                                    color="primary"
                                    @click="openNewTransfer()"
                                    rounded
                                    variant="elevated"
                                >
                                    Adicionar
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider></v-divider>
                </template>
                <template #headers="{ columns }">
                    <tr class="custom-header" >
                        <th v-for="column in columns" :key="column.key" style="text-align: center; font-weight: 600;">
                            {{ column.title }}
                        </th>
                    </tr>
                </template>

                <template v-slot:[`item.transferDate`]="{ item }">
                    {{ formatDateTime(item.transferDate) }}
                </template>
            </v-data-table-server>
        </v-card>
    </div>
    <StockTransfer/>
</template>

<script>
import StockTransfer from '../StockTransfer.vue';
import { useDisplay } from 'vuetify'

export default {
    setup () {
        const { mobile } = useDisplay()
        return { mobile }
    },
    data: () => ({
    }),
    components: {
        StockTransfer
    },
    computed: {
        transfer: {
            get() {
                return this.$store.state.transfer
            },
        },
    },
    methods: {
        async openTransfer(event, row) {
            this.$router.push({
                name: 'EditTransfer',
                params: {
                    transferId: row.item.transferId
                }
            })
        },
        openNewTransfer() {
            this.$router.push({ name: 'NewTransfer' })
        },
        async search() {
            await this.$store.dispatch("transfer/search", { limit: this.transfer.itemsPerPage, reset: true })
        },
        formatDateTime(date) {
            if (!date) return ''

            return new Date(date).toLocaleString('pt-BR', {
                dateStyle: 'short',
                timeStyle: 'short'
            })
        },
        async updateOptions(options) {
            this.$store.commit('transfer/setPage', options.page)

            await this.$store.dispatch("transfer/search", {
                limit: options.itemsPerPage,
                page: options.page,
                reset: true
            })
        }
    },
    async mounted() {
        await this.search()
    },
    watch: {
        '$store.state.transfer.shouldReload': {
            async handler(val) {
                if (val) {
                    await this.search()
                    this.$store.commit('transfer/setShouldReload', false)
                }
            }
        }
    }
}
</script>

<style>
.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>